import React from 'react';
import { Card, Skeleton } from 'styles';

export const LoadingGeneric = props => (
  <Card mobileVariant="flat" {...props}>
    <Card.Header>
      <Skeleton
        data-testid="loading-generic"
        height="40px"
        variant="secondary"
        width="80%"
        withShimmer
      />
    </Card.Header>
    <Card.Content>
      <Skeleton
        height="72px"
        margin={{ bottom: '24px', top: '8px' }}
        variant="secondary"
        width="100%"
        withShimmer
      />
      <Skeleton height="72px" variant="secondary" width="100%" withShimmer />
    </Card.Content>
  </Card>
);
